import React from 'react'
import styled, { css } from 'styled-components'

import { clTransform } from 'src/utils/cloudinary'

interface Props {
  src: string
  fluid?: boolean
  retina?: boolean
  alt?: string
  className?: string
  width?: number
  height?: number
  quality?: number
  onClick?: (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => void
}

export const Image: React.FC<Props> = ({
  src,
  fluid,
  className,
  alt,
  width,
  height,
  retina,
  quality,
  onClick,
}) => {
  const isSvg = src.includes('.svg')
  const srcUrl = clTransform({
    url: src,
    half: !isSvg && retina,
    q: quality,
  })
  const srcSetUrl =
    !isSvg && retina ? `${clTransform({ url: src, q: quality })} 2x` : undefined

  return (
    <Wrapper
      src={srcUrl}
      srcSet={srcSetUrl}
      fluid={fluid}
      className={className}
      width={width}
      height={height}
      alt={alt}
      onClick={onClick}
      hover={Boolean(onClick)}
    />
  )
}

interface WrapperProps {
  fluid?: boolean
  hover?: boolean
}

const Wrapper = styled.img<WrapperProps>`
  ${props =>
    props.fluid &&
    css`
      max-width: 100%;
      height: auto;
    `}

  ${props =>
    props.hover &&
    css`
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    `}
`
